import React from 'react';
import { renderRoutes, RouteConfigComponentProps } from 'react-router-config';
import { Switch, withRouter } from 'react-router-dom';

import './LoginConfigurationView.scss';
import LoginConfigurationMaster from './LoginConfigurationMaster/LoginConfigurationMaster';
import LoginConfigurationDetail from './LoginConfigurationDetail/LoginConfigurationDetail';

function LoginConfigurationView(props: RouteConfigComponentProps) {
  const { route } = props;

  return <Switch>{route && renderRoutes(route.children)}</Switch>;
}

export { LoginConfigurationMaster, LoginConfigurationDetail };
export default withRouter(LoginConfigurationView);
